import {FC, useMemo} from "react";
import {CreateResult, CreateResultSummary} from "../../view-model";
import {summarizeResult} from "../../helpers";
import {usePlan} from "../../context";
import {SummaryCard} from "../common";
import {OrganizationDetailsCard} from "./OrganizationDetailsCard";
import "../common/BuilderStep.scss";

export interface ResultsStepProps {
  result: CreateResult;
}

export const ResultsStep: FC<ResultsStepProps> = ({result}) => {
  const {plan} = usePlan();
  const summary = useMemo<CreateResultSummary>(
    () => summarizeResult(plan.source, result),
    [plan.source, result]
  );

  return (
    <section
      id={"results-step"}
      data-testid={"results-step"}
      className={"organization-builder-step results-step"}>
      <section
        id={"summary-section"}
        data-testid={"summary-section"}
        className={"summary-section"}>
        <SummaryCard
          baseLabelKey={"create-organization.result-summary"}
          qualifier={"created"}
          count={summary.created ? 1 : 0}
        />
        <SummaryCard
          baseLabelKey={"create-organization.result-summary"}
          qualifier={"failed"}
          count={summary.failed ? 1 : 0}
        />
      </section>
      <section
        id={"tenant-section"}
        data-testid={"tenant-section"}
        className={"tenant-section"}>
        {/* TenantDetailsCard Here */}
      </section>
      <section
        id={"organization-section"}
        data-testid={"organization-section"}
        className={"organization-section"}>
        <OrganizationDetailsCard input={plan.input} result={result} />
      </section>
    </section>
  );
};
